/**!
 * Apricot
 * @version 4.4.17
 * @author Mitra Assadi, Chuck (Sarah) Allison
 * @license
 * Copyright (c) 2022 The College Board
 */

/* ========================================================================
 * Apricot's Base
 * ======================================================================== */

// SCSS
import "../scss/includes/apricot-base.scss";

window.cb = window.cb || {};
window.cb.apricot = window.cb.apricot || {};
window.cb.apricot.version = "4.4.17";

// javaScript
export default {};
